import ButtonGeneralSumary from './ButtonGeneralSumary'

export default ButtonGeneralSumary
